'use client';

import { useMutation } from '@tanstack/react-query';

import { ImproveActivityDescriptionParams, improveActivityDescription } from '@website/services/activities.service';

export function useImproveActivityDescription() {
  return useMutation({
    mutationFn: (params: ImproveActivityDescriptionParams) => improveActivityDescription(params)
  });
}
